module.exports = __webpack_public_path__ + "img/hup.c71ca03a.png";